module.exports = __webpack_public_path__ + "static/media/ic-user.2ea456fc.svg";